export default __webpack_public_path__ + "static/media/logo.bda555db.png";